import {Csrf} from '../../editor/core/Csrf';
import {StoreController} from '../../editor/store/controllers/StoreController';

export class SearchExportControllerClass {
	private static _instance: SearchExportControllerClass;
	static instance() {
		return (this._instance = this._instance || new SearchExportControllerClass());
	}
	private constructor() {}

	async clearIndex() {
		const url = '/docs/search/clear_index';
		const formData = new FormData();
		// formData.append('key', key);
		// formData.append('file', file);
		const response = await fetch(url, {
			method: 'POST',
			body: formData,
			headers: {
				...Csrf.headers(),
				// 'Content-Type': 'application/json',
			},
		});
		const json = await response.json();
		console.log(json);
	}

	async downloadKey(key: string, content: string) {
		const url = '/docs/search/save_index';
		const file = new Blob([content], {type: 'text/plain'});
		const formData = new FormData();
		formData.append('key', key);
		formData.append('file', file);
		const response = await fetch(url, {
			method: 'POST',
			body: formData,
			headers: {
				...Csrf.headers(),
				// 'Content-Type': 'application/json',
			},
		});
		await response.json();
		console.log('save complete', key);
		if (response.ok) {
		} else {
			StoreController.editor.status.setError(`search index NOT downloaded for key ${key}`);
		}
	}
}
export const SearchExportController = SearchExportControllerClass.instance();
